import { render, staticRenderFns } from "./SideMenuGrouper.vue?vue&type=template&id=1b5fa6dc"
import script from "./SideMenuGrouper.vue?vue&type=script&lang=js"
export * from "./SideMenuGrouper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports